module.exports = __webpack_public_path__ + "static/media/mariposa-04.065d2f66.jpg";